import React, { useState, useEffect } from 'react';
import { getBacchusURL, remainingTime } from '../shared/Functions';
import { authProvider } from '../../services/Security';

export const MeterRoutes = (props) => {
    const [resetToken, setResetToken] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const url = getBacchusURL()

    useEffect(() => {
        if(!props.district) return;
        loadIframe()
        setResetToken(false)
    }, [resetToken, props.district])// eslint-disable-line react-hooks/exhaustive-deps

    const loadIframe = () => {
        setCount(count+1)
        authProvider.getNexusTokenFull().then(token => {
            setTimeout(() => setResetToken(true), remainingTime(token.tokenExpires))
            const frame = document.getElementById('meter-routes') as HTMLIFrameElement;
            frame?.contentWindow?.postMessage(JSON.stringify({
                token: token,
                districtId: props.district?.id
            }), url);
        })
    }

    return (
        <React.Fragment>
            <iframe id="meter-routes"
                title="meter-routes"
                src={`${url}/#/app/meter-routes`}
                width="1600px"
                height="1100px"
                onLoad={() => count > 1 ? null : loadIframe()}
                style={{border: "none", display:"block", marginLeft:"25px"}} />
        </React.Fragment>
    );
}